var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellow05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d4b653;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.09,30.69c0,1.99-1.56,3.6-3.47,3.6h-10.21l-5.4,7.2-4.71-7.2h-10.91c-1.92,0-3.47-1.61-3.47-3.6V13.03c0-1.99,1.55-3.6,3.47-3.6h31.23c1.92,0,3.47,1.61,3.47,3.6v17.66h0Zm-5.9-16.03h-26.19v2.35h26.19v-2.35h0Zm0,5.81h-26.19v2.35h26.19v-2.35h0Zm0,5.85h-26.19v2.35h26.19v-2.35h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.31,87.66h27.42c.43,0,.78.35.78.78v1.36c0,.43-.35.78-.78.78h-27.42c-.43,0-.78-.35-.78-.78v-1.36c0-.43.35-.78.78-.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.02,
    y: 63.3,
    width: 26,
    height: 23.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.7,
    y: 50.6,
    width: 16.64,
    height: 3.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.26,
    y: 46.98,
    width: 21.51,
    height: 2.82,
    rx: 0.78,
    ry: 0.78
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.02 62.5 26.7 54.52 43.34 54.52 48.02 62.5 22.02 62.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.62,62.5h0l.34-.58-4.96-4.14c-.33-.28-.85-.2-1.16.18l-.49.59c-.31.37-.3.9.03,1.17l5.68,4.74c.16.13.36.18.56.16v-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.66,58.56l-.49-.59c-.31-.37-.83-.45-1.16-.18l-4.94,4.12.35.6v2.13c.19.01.38-.03.53-.16l5.68-4.74c.33-.28.35-.8.04-1.17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellow05);
export default __webpack_public_path__ + "static/media/yellow05.572becae44aca0b5479c4f7f3265ffca.svg";
export { ForwardRef as ReactComponent };